<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
	<label for="" class="title-history">
		<i class="fa fa-map-location-dot"></i>Mapa Geográfico
	</label>
	<input type="radio" [(ngModel)]="tab" [value]="0" id="list">
	<label for="list">
		<i class="fa fa-route"></i>Mapa de Rutas
	</label>
	<input type="radio" [(ngModel)]="tab" [value]="1" id="creation">
	<label for="creation">
		<i class="fa fa-user-clock"></i>Días Inactivos Clientes
	</label>
</div>
<div class="card">
	<div class="card-body">
		<app-geographic-map-routes [hidden]="tab != 0"  *ngIf="tab==0"></app-geographic-map-routes>
		<app-clients-inactive-days [hidden]="tab != 1"  *ngIf="tab==1"></app-clients-inactive-days>
	</div>
</div>